export default "__VITE_ASSET__DKj_U_17__"